
const allEnv = Object.keys(process.env)
  .reduce((env, key) => {
    env[key] = process.env[key];
    return env;
  }, {} as Record<string, string | undefined>)

enum EnvList {
  dev = 'dev',
  development = 'dev',
  staging = 'staging',
  uat = 'uat',
  prod = 'prod',
  production = 'prod',
  /** Matches REACT_APP_ENV=preProduction (lowercased) so flags use *_PROD, not *_DEV */
  preproduction = 'prod',
}
const envList: Record<keyof typeof EnvList, string> = { ...EnvList }
const rawEnv = process.env.REACT_APP_ENV?.toLowerCase() ?? 'dev'

const Node_Env = envList[rawEnv as keyof typeof envList] ?? envList.dev
// Note: Old logic for environment
// const Node_Env = process.env.REACT_APP_ENV?.toLowerCase() === EnvList.dev ? '' : process.env.REACT_APP_ENV?.toLowerCase() === 'prod' ? 'PROD' : process.env.REACT_APP_ENV === 'Uat' ? 'UAT' : process.env.REACT_APP_ENV === 'Staging' ? 'Staging' : 'Development';

const apiList: Record<string, string> = {
    dev: 'http://localhost:8080/api',
    uat: 'https://filemule-internal-api-uat-c7cvhdarhxcqexgr.centralus-01.azurewebsites.net/api',
    staging: 'https://filemule-internal-api-staging-bqgvf9cdh5ard6hw.centralus-01.azurewebsites.net/api',
    prod: 'https://filemule-internal-api-c7cvhdarhxcqexgr.centralus-01.azurewebsites.net/api',
    // live: 'http://filemule-api-live.azurewebsites.net/api',
};

const API_URL = apiList[Node_Env];

/**
 * Resolves REACT_APP_* feature flags.
 * If `REACT_APP_<NAME>_<NODE_ENV>` is set (non-empty), it **overrides** the base `REACT_APP_<NAME>`.
 * This avoids the old base-OR-env behavior where `REACT_APP_ENABLE_*=false` could still be true
 * when a per-environment variable was also set, and lets you turn a flag off for one env only.
 */
const getFeatureFlag = (baseEnvVar: string) => {
    const envSpecificVar = `${baseEnvVar}_${Node_Env.toUpperCase()}`;
    const envRaw = process.env[envSpecificVar];
    const baseRaw = process.env[baseEnvVar];

    if (envRaw != null && String(envRaw).trim() !== '') {
        return String(envRaw).toLowerCase().trim() === 'true';
    }
    return (baseRaw?.toLowerCase() ?? 'false') === 'true';
};

export const AppFlags = {
    // stateReports: getFeatureFlag('REACT_APP_FLAG_STATE_REPORTS'),
    // otherReports: getFeatureFlag('REACT_APP_FLAG_OTHER_REPORTS'),
    /** Nav, State Reports Billing screen, and MEB ZIP State Reports PDFs (REACT_APP_ENABLE_STATE_REPORTS). */
    enableStateReports: getFeatureFlag('REACT_APP_ENABLE_STATE_REPORTS'),
    enableOtherReports: getFeatureFlag('REACT_APP_ENABLE_OTHER_REPORTS'),
    enableNonPremiumEndorsement: getFeatureFlag('REACT_APP_ENABLE_NON_PREMIUM_ENDORSEMENT'),
    enableYearToDateReport: getFeatureFlag('REACT_APP_ENABLE_YEAR_TO_DATE_REPORT'),
    enableCarrierPolicyDetails: getFeatureFlag('REACT_APP_ENABLE_CARRIER_POLICY_DETAILS'),
};
// Per-env override: set REACT_APP_<FLAG>_STAGING (etc.) to override REACT_APP_<FLAG> for that build.

const config = {
  allEnv,     // Note: all variables in .env
  Node_Env,   // Note: Current Environment.
  envList,    // Note: List of environments.
  url: {
    API_URL   // Note: API URL for the current enviroment.
  },
  AppFlags,   // Note: Feature Flag configuration for the current environment.
}

export default config
